// export const canNavigate = (to, modules) =>
//   to.matched.some((route) => {
//     if (!modules) {
//       indexedDB.deleteDatabase("zergdb");
//       localStorage.clear();
//       return false;
//     }

//     let access = false;
//     access = modules.includes(route.meta.module);
//     return access;
//   });
export const canNavigate = (to, sections, child) =>
  to.matched.some((route) => {
    if (!sections) {
      indexedDB.deleteDatabase("zergdb");
      localStorage.clear();
      return false;
    }
    let access = false;
    const current_section = child.meta.section;
    access = sections.includes(current_section);
    return access;
  });
//   mounted() {
//     const currentRoute = this.$route.matched[this.$route.matched.length - 1];
//     const childMeta = currentRoute.meta;
//     console.log(childMeta); // logs the meta object of the current child route
//   }
// }
// In this example, we access the matched property of the $route object and use array indexing to get the last route record, which corresponds to the current child route. Then, we access the meta property of that route record to get the meta object of the current child route.

// Note that if you have nested child routes
